import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export default function ZohoSalesIQ() {

    const user_name = useSelector((store) => store?.profileDetails?.name);
    const location = useLocation();
    const user_id = useSelector((store) => store?.profileDetails?.id);
    const email = useSelector((store) => store?.profileDetails?.email);

  useEffect(() => {
   
    
    if(user_id){
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'zsiqchat';
    script.innerHTML = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "7134c05d4c6d7c1fe40592d3d993f2b933d6a0a1790e6e65ca446fa4d03f96ab50c46591b23255da3fefd7bb1c66428a", values:{},ready:function(){$zoho.salesiq.visitor.name("${user_name?.split(" ")?.[0]}}"); $zoho.salesiq.visitor.email("${email}")}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zoho.in/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);`;

    console.log('mounted')
    document.body.appendChild(script);
    
    const divElement = document.getElementsByClassName('zsiq_floatmain');
    console.log(divElement)
    // const chatBox = document.getElementByClassName("zsiq_float")
    // chatBox.addEventListner('click', ()=> {
    //   console.log('clicked')
    // })
    // console.log(chatBox)
    // if(divElement[0])
    // { 
    //   console.log(divElement , 'divElement');
    //   console.log(divElement[0], 'div0')
    //   divElement[0].style.display = '';
    // }

  }
    return () => {

        // const scriptElement = document.getElementById('zsiqchat');
        // if (scriptElement) {
        //   scriptElement.remove();
          
        // }
        // const divElements = document.querySelectorAll('.zsiq_floatmain');
        // console.log(divElements , 'elements');
        // divElements.forEach(div => document.body.removeChild(div));
        // const scriptElement = document.getElementById('zsiqscript');
        // scriptElement.parentNode.removeChild(scriptElement);
        //window.location.reload();
        // console.log("unmounting")
        // const salesiqScript = document.getElementById('zsiqscript');
        // if (salesiqScript) {
        //   console.log("inside if");
        //   salesiqScript.parentNode.removeChild(salesiqScript);
        //   //window.location.reload();
        //   const divElement = document.getElementsByClassName('zsiq_floatmain');
        //   //divElement.removeAttribute('style');
        //   divElement[0].style.display = 'none';
        //   console.log(divElement, 'nodelist')
        // }

        //document.body.removeChild(script);
    };
  }, [user_id]);

  return <></>;
}